/* tslint:disable */
/* eslint-disable */
import * as runtime from '../runtime';
import type { TariffCategory } from '../models/index';
import {
    TariffCategoryFromJSON,
    TariffCategoryToJSON,
} from '../models/index';

export interface TariffCategoryFindRequest {
    filter?: string;
}

export interface TariffCategoryCreateRequest {
    data: Partial<TariffCategory>;
}

export interface TariffCategoryPatchAttributesRequest {
    id: number;
    data: Partial<TariffCategory>;
}

/**
 * TariffCategory API (/TariffCategories). Reads are public; writes are Overlord-only.
 */
export class TariffCategoryApi extends runtime.BaseAPI {

    async tariffCategoryFindRaw(requestParameters: TariffCategoryFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TariffCategory>>> {
        const queryParameters: any = {};
        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }
        const headerParameters: runtime.HTTPHeaders = {};
        const response = await this.request({
            path: `/TariffCategories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TariffCategoryFromJSON));
    }

    async tariffCategoryFind(requestParameters: TariffCategoryFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TariffCategory>> {
        const response = await this.tariffCategoryFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async tariffCategoryCreateRaw(requestParameters: TariffCategoryCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TariffCategory>> {
        if (requestParameters['data'] == null) {
            throw new runtime.RequiredError('data', 'Required parameter "data" was null or undefined when calling tariffCategoryCreate().');
        }
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/TariffCategories`,
            method: 'POST',
            headers: headerParameters,
            query: {},
            body: TariffCategoryToJSON(requestParameters['data']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => TariffCategoryFromJSON(jsonValue));
    }

    async tariffCategoryCreate(requestParameters: TariffCategoryCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TariffCategory> {
        const response = await this.tariffCategoryCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async tariffCategoryPatchAttributesRaw(requestParameters: TariffCategoryPatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TariffCategory>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling tariffCategoryPatchAttributes().');
        }
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/TariffCategories/${encodeURIComponent(String(requestParameters['id']))}`,
            method: 'PATCH',
            headers: headerParameters,
            query: {},
            body: TariffCategoryToJSON(requestParameters['data']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => TariffCategoryFromJSON(jsonValue));
    }

    async tariffCategoryPatchAttributes(requestParameters: TariffCategoryPatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TariffCategory> {
        const response = await this.tariffCategoryPatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
